export default __webpack_public_path__ + "static/media/Abstract.bf969afc.jpg";